import { FC } from "react";

const ChatIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props} // allows overriding size, color, etc.
  >
    <rect
      x="0.5"
      width="36"
      height="36"
      rx="6.75"
      fill="#71B48D"
      fillOpacity="0.12"
    />
    <path
      d="M10.4297 26V11.5C10.4297 11.0875 10.5766 10.7344 10.8703 10.4406C11.1641 10.1469 11.5172 10 11.9297 10H24.9297C25.3422 10 25.6953 10.1469 25.9891 10.4406C26.2828 10.7344 26.4297 11.0875 26.4297 11.5V21.5C26.4297 21.9125 26.2828 22.2656 25.9891 22.5594C25.6953 22.8531 25.3422 23 24.9297 23H13.4297L10.4297 26ZM12.8047 21.5H24.9297V11.5H11.9297V22.375L12.8047 21.5Z"
      fill="#518B8A"
    />
  </svg>
);

export default ChatIcon;
